import { render, staticRenderFns } from "./Index-GeneralSalesScreen.vue?vue&type=template&id=54a86366"
import script from "./Index-GeneralSalesScreen.vue?vue&type=script&lang=js"
export * from "./Index-GeneralSalesScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports